import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchDeployedRegions } from './../../../../actions/closeLoop/apmDashboard/region/regionsActions';

import { Container, Alert, Spinner } from 'react-bootstrap';
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
//   ZoomableGroup
} from "react-simple-maps";
import PropTypes from "prop-types";


function Loader() {
    return (
        <div style={{ paddingTop: '15%' }}>
            <h2 className='text-center' style={{ fontWeight: '900' }}>
                Fetching Deployed Regions ...
            </h2>
            <div className='text-center'>
                <Spinner
                    animation="border"
                    role="status"
                    style={{
                        height: '100px',
                        width: '100px',
                        margin: 'auto',
                        display: 'block'
                    }}
                >
                </Spinner>
            </div>
        </div>
    )
}


function DeployedRegions(props) {
    const geoUrl = "https://raw.githubusercontent.com/deldersveld/topojson/master/world-countries.json";

    useEffect(() => {
        props.getDeployedRegions();
    }, [])

    const handleClick = (e) => {
        const selectedRegion = e.target.innerHTML;
        const regionInfo = props.deployedRegions.find((item) => item['name'] === selectedRegion)
        console.log(props);
        props.history.push(`/close_loop/running/bench-instances/${regionInfo.code}`)
    }

    console.log("Deployed ", props);

    return (
        <>
            { props.loading ? <Loader /> : props.error ? (
                <Alert variant='danger'>{ props.error }</Alert>) : props.deployedRegions.length === 0 ? (
                <Alert variant='info'>No instances are currently deployed/running in a region</Alert>) : (
                    <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                        <Container style={{ width: "auto", minWidth: "100%" }}>
                            <ComposableMap>
                                <Geographies geography={geoUrl}>
                                    {({ geographies }) =>
                                        geographies.map(geo =>
                                        <Geography key={geo.rsmKey} geography={geo} />)
                                    }
                                </Geographies>
                                { props.deployedRegions.map((item) => (
                                    <Marker
                                        coordinates={item.coordinates}
                                        key={item.name}
                                        onClick={handleClick}
                                    >
                                        <g
                                            className="custom-marker"
                                            key={item.name}
                                            fill="none"
                                            stroke="#622AD8"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            transform="translate(-12, -24)"
                                            value={item.name}
                                            onClick={handleClick}
                                        >
                                            <circle key={item.name} cx="12" cy="10" r="3" />
                                            <path d="M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 6.9 8 11.7z" />
                                        </g>
                                        <text
                                            className="custom-region"
                                            textAnchor="middle"
                                            value={item.code}
                                            y={item.markerOffset}
                                            style={{ fontFamily: "system-ui", fill: "#B0FF44", cursor: "pointer" }}

                                        >
                                          {item.name}
                                        </text>
                                    </Marker>
                                )) }
                            </ComposableMap>
                        </Container>
                    </div>
                ) }
        </>
    )
}

const mapStateToProps = (state) => ({
    loading: state.deployedRegions.loading,
    error: state.deployedRegions.error,
    deployedRegions: state.deployedRegions.regions,
});

const mapDispatchToProps = (dispatch) => ({
    getDeployedRegions: () => dispatch(fetchDeployedRegions()),
});

DeployedRegions.propTypes = {
    getDeployedRegions: PropTypes.func,
    deployedRegions: PropTypes.array,
    history: PropTypes.object,
    loading: PropTypes.bool,
    error: PropTypes.string,
};
DeployedRegions.defaultProps = {
    deployedRegions: [],
    history: {},
    loading: false,
    error: '',
    selectedInstance: '',
};

export default connect(mapStateToProps, mapDispatchToProps)(DeployedRegions);